"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableRows = void 0;
var table_rows_component_1 = require("./table-rows.component");
Object.defineProperty(exports, "TableRows", { enumerable: true, get: function () { return table_rows_component_1.TableRows; } });
